import { useContext, useEffect, useState } from "react";
import ReactDOM from "react-dom";

import Filter from "./Filter";
import Card from "../../common/TourItem";
import { FilterModal } from "admin-panel/tour-list/Modals";
import TourTab from "admin-panel/tour-list/TourTab";
import UserModal from "../../common/UserModal";

import { searchTour } from "../../services/adminTourList";

import ReservationContext from "./ReservationContext";
import ModalContext from "./ModalContext";
import { PayModal } from "./Modals";
import { convertDate } from "utilities/helperFunction";

export function ReserveComponents({ factors, order = false }) {
  const [id, setId] = useState("");
  const [updater, setUpdater] = useState(false);
  const {
    cancelFactor,
    getModalData,
    editModalChanger,
    updateModal,
    changeFactorId,
    changeTourId,
    payModalDataHandler,
  } = useContext(ModalContext);

  function prepareCard() {
    return factors.map((value, index) => {
      let x = value.factor.total_amt - value.factor.total_paid;
      let res = [
        {
          title: "عنوان تور",
          description: value.tour.title,
        },
        {
          title: "نام خریدار",
          description: (
            <button
              className="btn btn-link"
              data-bs-target="#userInfo"
              data-bs-toggle="modal"
              onClick={() => {
                setId(value.buyer.id);
                setUpdater(!updater);
              }}
              key={`reserve${index}-passenger0`}
            >
              {value.buyer.fullname}
            </button>
          ),
        },
        {
          title: "تعداد ثبت نامی",
          description: value.factor.total_count,
        },
        {
          title: "مبلغ واحد",
          description: Math.floor(
            value.factor.total_amt / value.factor.total_count
          ),
        },
        {
          title: "قیمت کل",
          description: value.factor.total_amt,
        },
        {
          title: "تاریخ",
          description: convertDate(value.mtm),
        },
        {
          title: "مبلغ پرداخت شده",
          description: value.factor.total_paid,
        },
        {
          title: "مانده حساب",
          description: x > 0 ? x : 0,
        },
      ];
      if (value.passangers.length > 0) {
        let temp = {
          title: "نام همراهان",
          description: "",
        };
        temp.description = value.passangers.map((val, ind) => {
          return (
            <>
              {ind != 0 && "، "}
              <button
                className="btn btn-link"
                data-bs-target="#userInfo"
                data-bs-toggle="modal"
                onClick={() => {
                  setId(val.id);
                  setUpdater(!updater);
                }}
                key={`reserve${index}-passenger${ind + 1}`}
              >
                {val.fullname}
              </button>
            </>
          );
        });
        res.splice(2, 0, temp);
      }
      return (
        <Card
          index={index}
          type={order ? "order" : "reserve"}
          key={`${order ? "order" : "reserve"}-card-${index}`}
          data={res}
          editHandler={() => {
            getModalData(value.id);
            editModalChanger(!order);
            updateModal();
            changeFactorId(value.id);
            changeTourId(value.tour.id);
          }}
          payModal={() => {
            payModalDataHandler({
              factorId: value.id,
              price: x,
            });
          }}
          cancelFactor={() => cancelFactor(value.id)}
        ></Card>
      );
    });
  }

  return (
    <>
      <Filter order={order} />
      {prepareCard()}
      {ReactDOM.createPortal(
        <>
          <UserModal id={id} Updater={updater} />
          <PayModal />
        </>,
        document.querySelector(".modals")
      )}
    </>
  );
}

export function ReserveLists({ order = false }) {
  const { reservations } = useContext(ReservationContext);
  const { SDHandler, selectedSearchData } = useContext(ModalContext);

  const [reserves, setReserves] = useState([]);

  useEffect(() => {
    let d = reservations.reduce(
      (total, value) => {
        if (
          value.tour.title?.trim() != "" &&
          value.tour.title != null &&
          typeof total.tours.find((val) => val.value == value.tour.id) ===
            "undefined"
        ) {
          total.tours.push({
            value: value.tour.id,
            label: `${value.tour.title} - ${value.tour.stm}`,
          });
        }
        if (
          value.buyer.fullname.trim() != "" &&
          typeof total.users.find((val) => val.value == value.buyer.id) ===
            "undefined"
        ) {
          total.users.push({
            value: value.buyer.id,
            label: value.buyer.fullname,
          });
        }
        total.users = total.users.concat(
          value.passangers.reduce((tot, val) => {
            if (
              val.fullname.trim() != "" &&
              typeof total.users.find((v) => v.value === val.id) ===
                "undefined" &&
              typeof tot.find((v) => v.value === val.id) === "undefined"
            ) {
              return [
                ...tot,
                {
                  value: val.id,
                  label: val.fullname,
                },
              ];
            }
            return tot;
          }, [])
        );
        return total;
      },
      { tours: [], users: [] }
    );
    SDHandler(d);
  }, [reservations]);

  useEffect(() => {
    if (
      selectedSearchData.tourId == -1 &&
      selectedSearchData.userIds.length == 0 &&
      selectedSearchData.paymentVal == -1
    ) {
      setReserves(reservations);
    } else {
      setReserves(
        reservations.filter((value) => {
          if (
            selectedSearchData.paymentVal != -1 &&
            value.total_pay_state != selectedSearchData.paymentVal
          )
            return false;
          if (
            selectedSearchData.tourId != -1 &&
            value.tour.id != selectedSearchData.tourId
          )
            return false;
          if (selectedSearchData.userIds.length == 0) return true;
          let counter = 0;
          if (selectedSearchData.userIds.includes(value.buyer.id)) counter++;
          if (
            value.passangers.filter((val) =>
              selectedSearchData.userIds.includes(val.id)
            ).length ==
            selectedSearchData.userIds.length - counter
          )
            return true;
          return false;
        })
      );
    }
  }, [reservations, selectedSearchData]);

  if (order) {
    return <ReserveComponents factors={reserves} order />;
  }

  return (
    <>
      <div
        class="tab-pane fade show active"
        id="active-tour-list"
        role="tabpanel"
        aria-labelledby="home-tab"
      >
        <ReserveComponents
          factors={reserves?.filter((value) => value.tour.main_status == 4)}
        />
      </div>
      <div
        class="tab-pane fade"
        id="tour-list-history"
        role="tabpanel"
        aria-labelledby="profile-tab"
      >
        <ReserveComponents
          factors={reserves?.filter((value) => value.tour.main_status == 2)}
        />
      </div>
    </>
  );
}

export function ToursTab() {
  const { tours, getInfo, loadingHandler } = useContext(ReservationContext);
  const { maxPrice } = useContext(ModalContext);
  const [priceOptions, setPriceOptions] = useState({
    max: 50000000,
    step: 500000,
  });
  const [filterInputs, setFilterInputs] = useState({
    title: "",
    priceRange: [0, 0],
    transferType: 0,
    duration: 0,
    stm: "",
    ftm: "",
  });

  async function search() {
    loadingHandler(true);
    let conditions = await searchTour(filterInputs);
    await getInfo(conditions);
    loadingHandler(false);
  }

  async function resetFilters() {
    loadingHandler(true);
    setFilterInputs({
      title: "",
      priceRange: [0, priceOptions.max],
      transferType: 0,
      duration: 0,
      stm: "",
      ftm: "",
    });
    await getInfo();
    loadingHandler(false);
  }

  useEffect(() => {
    setPriceOptions({ ...priceOptions, max: maxPrice });
    setFilterInputs({ ...filterInputs, priceRange: [0, maxPrice] });
  }, [maxPrice]);
  return (
    <>
      <div class="tab-pane fade" id="tours-tab">
        <TourTab tours={tours} reservation getInfo={getInfo} />
      </div>
      {ReactDOM.createPortal(
        <>
          <FilterModal
            filterInputs={filterInputs}
            setFilterInputs={setFilterInputs}
            priceOptions={priceOptions}
            search={search}
            resetFilters={resetFilters}
          />
        </>,
        document.getElementsByClassName("modals")[0]
      )}
    </>
  );
}
